import { useFeature } from "../features";
import { useObjectMemo } from "../../../hooks";

export const useIsDashboardCustomizationEnabled = () => {
  const { featureEnabled, features } = useFeature();

  return useObjectMemo({
    isDashboardCustomizationEnabled: featureEnabled(
      "olb_dashboard_customization",
    ),
    dashboardCustomizationLockedFields:
      features.olb_dashboard_customization_locked_positions,
  });
};
